import React from "react";
import { Typography } from "@mui/material";
import { buildHealthIndicatorIcon, buildSessionHealthColor } from "../../../helpers/HealthIndicatorBuilder";
import { CenteredBox, ColoredAvatar } from "../../themes/styled";
import moment from "moment-timezone";
import { COMPACT_TIME_FORMAT } from "../../../config/DateTimeConstants";

export default function PerformerCheckinHealth({ session, state }) {
  const backgroundColor = buildSessionHealthColor[state];
  const icon = buildHealthIndicatorIcon("performer-checked-in");

  const checkInTime = session.shift.performerCheckInTime;
  const formattedTime = checkInTime ? moment(checkInTime).format(COMPACT_TIME_FORMAT) : "N/A";

  return (
    <CenteredBox>
      <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
      <Typography variant="body2" sx={{ mr: "-0.25rem" }}>Performer Checked In</Typography>
      <Typography variant="body2">({formattedTime})</Typography>
    </CenteredBox>
  );
}